import {WorkflowType} from "../../utils/enums";
import {WorkflowOption} from "./types";

export const WORKFLOW_OPTIONS: Record<WorkflowType, WorkflowOption> = {
  [WorkflowType.ADMISSION]: {
    type: WorkflowType.ADMISSION,
    label: "Admission",
  },
  [WorkflowType.ARBITRATION]: {
    type: WorkflowType.ARBITRATION,
    label: "Arbitration",
  },
  [WorkflowType.ADMISSION_SPANISH]: {
    type: WorkflowType.ADMISSION_SPANISH,
    label: "Admission (Spanish)",
  },
  [WorkflowType.READMISSION]: {
    type: WorkflowType.READMISSION,
    label: "Readmission",
  },
  [WorkflowType.READMISSION_SPANISH]: {
    type: WorkflowType.READMISSION_SPANISH,
    label: "Readmission (Spanish)",
  },
};

/** Static labels for known workflow types; facility-specific lists come from WorkflowService. */
